export interface CallTypeOption {
  label: string;
  classOfService: string;
  secondaryCallType: string;
  category: string;
}

export const CALL_TYPE_OPTIONS: CallTypeOption[] = [
  // Landline
  {
    label: 'Landline - RESD (Residential)',
    classOfService: 'RESD',
    secondaryCallType: 'legacyWireline',
    category: 'Landline',
  },
  {
    label: 'Landline - BUSN (Business)',
    classOfService: 'BUSN',
    secondaryCallType: 'legacyWireline',
    category: 'Landline',
  },
  {
    label: 'Landline - PBXB (PBX Business)',
    classOfService: 'PBXB',
    secondaryCallType: 'legacyWireline',
    category: 'Landline',
  },
  {
    label: 'Landline - CNTX (Context)',
    classOfService: 'CNTX',
    secondaryCallType: 'legacyWireline',
    category: 'Landline',
  },
  {
    label: 'Landline - COIN (Coin/Pay Phone)',
    classOfService: 'COIN',
    secondaryCallType: 'legacyWireline',
    category: 'Landline',
  },
  // Phase1
  {
    label: 'Phase1 - WPH1 (Wireless Phase 1)',
    classOfService: 'WPH1',
    secondaryCallType: 'legacyWireless',
    category: 'Phase1',
  },
  {
    label: 'Phase1 - MOBL (Mobile)',
    classOfService: 'MOBL',
    secondaryCallType: 'legacyWireless',
    category: 'Phase1',
  },
  {
    label: 'Phase1 - WRLS (Wireless)',
    classOfService: 'WRLS',
    secondaryCallType: 'legacyWireless',
    category: 'Phase1',
  },
  {
    label: 'Phase1 - W911 (Wireless 911)',
    classOfService: 'W911',
    secondaryCallType: 'legacyWireless',
    category: 'Phase1',
  },
  // Phase2
  {
    label: 'Phase2 - WPH2 (Wireless Phase 2)',
    classOfService: 'WPH2',
    secondaryCallType: 'legacyWireless',
    category: 'Phase2',
  },
  // VOIP
  {
    label: 'VOIP - VOIP',
    classOfService: 'VOIP',
    secondaryCallType: 'legacyVoip',
    category: 'VOIP',
  },
  {
    label: 'VOIP - VBUS (VoIP Business)',
    classOfService: 'VBUS',
    secondaryCallType: 'legacyVoip',
    category: 'VOIP',
  },
  {
    label: 'VOIP - VRES (VoIP Residential)',
    classOfService: 'VRES',
    secondaryCallType: 'legacyVoip',
    category: 'VOIP',
  },
  {
    label: 'VOIP - VNOM (VoIP Nominal)',
    classOfService: 'VNOM',
    secondaryCallType: 'legacyVoip',
    category: 'VOIP',
  },
  {
    label: 'VOIP - VENT (VoIP Enterprise)',
    classOfService: 'VENT',
    secondaryCallType: 'legacyVoip',
    category: 'VOIP',
  },
  {
    label: 'VOIP - VMBL (VoIP Mobile)',
    classOfService: 'VMBL',
    secondaryCallType: 'legacyVoip',
    category: 'VOIP',
  },
  // Other
  {
    label: 'Other - PAY$ (Pay Phone)',
    classOfService: 'PAY$',
    secondaryCallType: 'legacyWireline',
    category: 'Other',
  },
  {
    label: 'Other - PBXR (PBX Residential)',
    classOfService: 'PBXR',
    secondaryCallType: 'legacyWireline',
    category: 'Other',
  },
  {
    label: 'Other - TEXT (Text)',
    classOfService: 'TEXT',
    secondaryCallType: 'legacyWireline',
    category: 'Other',
  },
  {
    label: 'Other - NA (Not Available)',
    classOfService: 'NA',
    secondaryCallType: 'legacyWireline',
    category: 'Other',
  },
  {
    label: 'Other - TLMA (Telematics)',
    classOfService: 'TLMA',
    secondaryCallType: 'legacyWireline',
    category: 'Other',
  },
];

const defaultCallType = CALL_TYPE_OPTIONS.find(
  o => o.classOfService === 'WPH1',
);

if (!defaultCallType) {
  throw new Error(
    'DEFAULT_CALL_TYPE could not be found in CALL_TYPE_OPTIONS. WPH1 call type is required.',
  );
}

export const DEFAULT_CALL_TYPE = defaultCallType;
